import cropApplicationDraftService from "./cropApplicationDraftService";
import processingApplicationDraftService from "./processingApplicationDraftService";


const applicationDraftService = [
    ...cropApplicationDraftService,
    ...processingApplicationDraftService
]

export default applicationDraftService;